import React from "react";
import { LabelType } from "@/types/appTypes/general";
import { ReadOnlyContainer } from "capitalrx-components";
import SectionContainer from "@/App/components/SectionContainer";

interface Props {
  fieldGroupName: string;
  fieldGroupFields: Array<LabelType>;
}

const PricingField: React.FC<Props> = (props: Props) => {
  const { fieldGroupFields, fieldGroupName } = props;
  const formatFieldGroupName = (fieldGroupName: string): string => {
    // Format camelCase keys to Sentence Case titles.
    const spaced = fieldGroupName.replace(/([A-Z])/g, " $1");
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  };

  return (
    <SectionContainer headerTitle={formatFieldGroupName(fieldGroupName)} abilityToClose sectionTitleWithBtn>
      <div className="row">
        {fieldGroupFields.map((field: LabelType) => (
          <div className="col pricing-field-column" key={field.label.replace(/ /g, "-")}>
            <ReadOnlyContainer showLabel label={field.label} body={field.value} />
          </div>
        ))}
      </div>
    </SectionContainer>
  );
};

export default PricingField;
